import React from "react";
import { Flex } from "@chakra-ui/react";
import { Body } from "../../Typography";
import Link from "next/link";
import { Info } from "../../Icon/Icon";

const BottomCardInfoV2 = () => {

  return (
    <Link href="/my-account/user-guide">
      <Flex
        bg={"white"}
        data-testid="card_bottomInfo_userGuide"
        cursor="pointer"
        width="100%"
        height="100%"
        padding="8px"
        borderRadius="8px"
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Flex justifyContent={"space-between"} alignItems={"center"} gap="8px">
          <Info />
          <Body
            data-testid="card_bottomInfo_userGuide_heading"
            variant="Bold10"
            color="shade02"
          >
            <span>Satu Akun untuk Semua Ekosistem IDN</span>
          </Body>
        </Flex>
        <Body
          data-testid="card_bottomInfo_userGuide_moreText"
          variant="Bold10"
          color="accent03"
        >
          Selengkapnya
        </Body>
      </Flex>
    </Link>
  );
};

export default BottomCardInfoV2;
